module.exports = __webpack_public_path__ + "img/nav-menu.1060dcba.png";